// @flow
import React, { Component } from 'react';
import type { LetterSequence } from 'store/modules/letters';
import { connect } from 'react-redux';
import type { State } from 'store';

import LetterSequences from 'components/letter/LetterSequences/LetterSequences';

type Props = {
  sequences: ?(LetterSequence[]),
  username: string,
  currentLetterId: string,
};

class LetterSequencesContainer extends Component<Props> {
  render() {
    const { sequences, username, currentLetterId } = this.props;

    return (
      <LetterSequences
        sequences={sequences}
        username={username}
        currentLetterId={currentLetterId}
      />
    );
  }
}

export default connect(
  ({ letters }: State) => ({
    sequences: letters.sequences,
    currentLetterId: letters.letter && letters.letter.id,
  }),
  () => ({}),
)(LetterSequencesContainer);



// WEBPACK FOOTER //
// ./src/containers/letter/LetterSequencesContainer.js